import React from 'react';
import { CheckCircle2, Play } from 'lucide-react';
export function FeatureAgenda() {
  return <section className="w-full border-b border-white/[0.06]" style={{
    backgroundColor: '#09090B'
  }} data-id="element-161">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28" data-id="element-162">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-163">
          {/* Text — Left */}
          <div data-id="element-164">
            <p className="text-xs uppercase tracking-wider font-mono text-blue-400" data-id="element-165">
              Agenda &amp; Engagement en direct
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-4 leading-tight font-heading" data-id="element-166">
              Le programme complet dans la plateforme. Des sessions qui sont des
              conversations, pas des diffusions.
            </h2>
            <div className="mt-8 space-y-5" data-id="element-167">
              <div className="flex items-start gap-3" data-id="element-168">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-169" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-170">
                  Agenda multi-track avec pages de sessions, liens speakers,
                  salles et capacité
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-171">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-172" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-173">
                  Les participants construisent leur planning personnel et
                  reçoivent des rappels
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-174">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-175" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-176">
                  Sessions diffusées directement dans la plateforme — aucune
                  redirection externe pour les participants hybrides
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-177">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-178" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-179">
                  Sondages par session déclenchés automatiquement à la fin de
                  chaque session
                </p>
              </div>
            </div>
          </div>

          {/* Visual — Right */}
          <div className="bg-white/[0.04] border border-white/[0.08] rounded-2xl p-6" data-id="element-180">
            <div className="grid grid-cols-2 gap-4" data-id="element-181">
              {/* Left half — Agenda track list */}
              <div className="space-y-2" data-id="element-182">
                <p className="text-white/40 text-[10px] font-mono uppercase tracking-wider mb-3" data-id="element-183">
                  Agenda
                </p>
                <div className="bg-white/[0.06] rounded-lg p-3 border-l-2 border-blue-500/40" data-id="element-184">
                  <div className="bg-white/[0.08] h-2 rounded w-3/4 mb-1.5" data-id="element-185" />
                  <div className="bg-white/[0.06] h-1.5 rounded w-1/2" data-id="element-186" />
                </div>
                <div className="bg-white/[0.06] rounded-lg p-3 border-l-2 border-purple-500/40" data-id="element-187">
                  <div className="bg-white/[0.08] h-2 rounded w-2/3 mb-1.5" data-id="element-188" />
                  <div className="bg-white/[0.06] h-1.5 rounded w-2/5" data-id="element-189" />
                </div>
                <div className="bg-white/[0.06] rounded-lg p-3 border-l-2 border-cyan-500/40" data-id="element-190">
                  <div className="bg-white/[0.08] h-2 rounded w-4/5 mb-1.5" data-id="element-191" />
                  <div className="bg-white/[0.06] h-1.5 rounded w-1/3" data-id="element-192" />
                </div>
                <div className="bg-white/[0.06] rounded-lg p-3 border-l-2 border-emerald-500/40" data-id="element-193">
                  <div className="bg-white/[0.08] h-2 rounded w-3/5 mb-1.5" data-id="element-194" />
                  <div className="bg-white/[0.06] h-1.5 rounded w-2/5" data-id="element-195" />
                </div>
              </div>

              {/* Right half — Stream player + Q&A */}
              <div className="space-y-3" data-id="element-196">
                <p className="text-white/40 text-[10px] font-mono uppercase tracking-wider mb-3" data-id="element-197">
                  En direct
                </p>
                {/* Video player */}
                <div className="bg-white/[0.06] rounded-lg aspect-video flex items-center justify-center border border-white/[0.08]" data-id="element-198">
                  <div className="w-10 h-10 rounded-full bg-white/[0.08] flex items-center justify-center" data-id="element-199">
                    <Play className="h-4 w-4 text-white/20 ml-0.5" data-id="element-200" />
                  </div>
                </div>
                {/* Q&A panel */}
                <div className="space-y-1.5" data-id="element-201">
                  <p className="text-white/30 text-[10px] font-mono uppercase" data-id="element-202">
                    Q&amp;A
                  </p>
                  <div className="bg-white/[0.06] rounded p-2 border border-white/[0.08]" data-id="element-203">
                    <div className="bg-white/[0.08] h-1.5 rounded w-4/5" data-id="element-204" />
                  </div>
                  <div className="bg-white/[0.06] rounded p-2 border border-white/[0.08]" data-id="element-205">
                    <div className="bg-white/[0.08] h-1.5 rounded w-3/5" data-id="element-206" />
                  </div>
                  <div className="bg-white/[0.06] rounded p-2 border border-white/[0.08]" data-id="element-207">
                    <div className="bg-white/[0.08] h-1.5 rounded w-2/3" data-id="element-208" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}